/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-23 09:04:20
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-10 17:51:56
 */
import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import createPersistedState from 'vuex-persistedstate' //防止页面刷新vuex数据消失
Vue.use(Vuex)
const store = new Vuex.Store({
    //防止页面刷新vuex数据消失, 以sessionStorage的形式，也可以是localStorage或者cookie（https://www.npmjs.com/package/vuex-persistedstate ，https://github.com/js-cookie/js-cookie#json）的形式
    // plugins: [createPersistedState({ storage: window.sessionStorage })],
    plugins: [createPersistedState({ storage: window.localStorage })],
    state,
    getters,
    mutations,
    actions
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js